import { IAssessment } from "@/modules/assessments/assessments.types";

export enum ClientStatus {
  Active = "active",
  Inactive = "inactive",
}

export interface IClientText {
  createdAt: string;
  updatedAt: string;
  clientTextId: number;
  body: Record<string, string> | null;
  clientId: number;
  locationId: number;
}

export interface IClientConfig {
  customCompetencyNames: {
    [testId: string]: {
      [competencyKey: string]: string;
    };
  };
}

export interface IClient {
  key?: number;
  clientId: number;
  name: string;
  logoUrl: string;
  status: ClientStatus;
  createdAt: string;
  updatedAt: string;
  clientUsers?: IClientUser[];
  assessments?: IAssessment[];
  selected?: boolean;
  config?: IClientConfig | null;
  clientTexts?: IClientText[];
  candidateRetentionPeriodDays: number;
  insightsEnabled: boolean;
}

export interface IClientCompetencies {
  testId: number;
  name: string;
  competencyId: number;
  testName: string;
  customCompetencyName: string;
  explanation: string | null;
  key: string;
}

export interface IClientUser {
  key?: number;
  name: string;
  createdAt?: string;
  updatedAt?: string;
  clientUserId: number;
  clientId: number;
  userId: number;
  roleId: number;
  email?: string;
  phone?: string;
  user: IUser;
  role: IRole;
}

interface IRole {
  createdAt: string;
  name: string;
  roleId: number;
  updatedAt: string;
}

export interface IUser {
  createdAt: string;
  updatedAt: string;
  userId: number;
  fullName: string;
  email: string;
  firebaseId: string;
  isAdmin: boolean;
  lastLogin: string;
  clientUsers?: IClientUser[];
  deletedOn: string;
  deletedBy: number | IUser;
}

export interface IUserForTable {
  key: number;
  userId: number;
  fullName: string;
  roleName: string;
  isClientLevelRole: boolean;
}
